import { useHasAnyRole, useHasBuiltinRole } from 'components/no-ui/capability'
import { getAdminNavItems, getAllRolesFromNavItems } from 'components/pages/sidebar/NavMetadata'
import { RoleID } from 'lib/constants/system'
import { AdminModeContext, AdminModeContextRecord, DashboardContext } from 'lib/context/app'
import { useRouter } from 'next/router'
import { FC, ReactNode, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

export const AdminModeContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const router = useRouter()
    const dashboardContext = useContext(DashboardContext)
    const intl = useIntl()
    const navItems = useMemo(() => getAdminNavItems(intl, dashboardContext), [intl, dashboardContext])

    const isOnAdminPath = router.asPath.startsWith('/admin')
    const adminRoles = getAllRolesFromNavItems(navItems)
    const isAnyAdminRole = useHasAnyRole(Array.from(adminRoles))
    const isReadOnlySuperAdmin = useHasBuiltinRole(RoleID.ReadOnlySuperAdmin)
    const hasAdminRole = isAnyAdminRole || isReadOnlySuperAdmin

    const adminModeContext = useMemo(
        () => new AdminModeContextRecord({ isOnAdminPath, hasAdminRole }),
        [isOnAdminPath, hasAdminRole],
    )

    return <AdminModeContext.Provider value={adminModeContext}>
        {children}
    </AdminModeContext.Provider>
}
